import { useMemo } from 'react';
import { visibleAdminRoutes, withoutElevatedOnlyRoutes } from 'routes/access';
import { RType } from 'routes/types';
import { useUserRole } from '../features/auth/roles';
import { useSelectedLocation } from '../features/location-management/hooks/useSelectedLocation';
import { useSelectedOrganization } from '../features/organization/hooks/useSelectedOrganization';
import { useElevatedAdminAccess } from '../features/organization/hooks/useIsElevatedAdmin';

export function useVisibleRoutes(): RType[] {
  const { selectedOrganization } = useSelectedOrganization();
  const { selectedLocation } = useSelectedLocation();
  const role = useUserRole();
  const { isElevated: isElevatedAdmin } = useElevatedAdminAccess();

  return useMemo(
    () =>
      withoutElevatedOnlyRoutes(
        visibleAdminRoutes({
          role,
          hasOrganization: Boolean(selectedOrganization),
          hasLocation: Boolean(selectedLocation),
        }),
        isElevatedAdmin,
      ),
    [role, selectedOrganization, selectedLocation, isElevatedAdmin],
  );
}
